import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { _getAllVisitors } from '../shared/httpservice/apis/visitor';
const createInitialState = () => ({
    loading: false,
    response: null,
    hasError: false,
    error: {},
});
const initialState = {
    visitors: createInitialState(),
};
export const fetchAllVisitors = createAsyncThunk('visitor/fetchAll', async ({ siteId, pageNumber = 0, pageSize = 10 }, { rejectWithValue }) => {
    try {
        const response = await _getAllVisitors(siteId, pageNumber, pageSize);
        return response;
    }
    catch (error) {
        return rejectWithValue(error?.response?.data || error.message);
    }
});
const visitorSlice = createSlice({
    name: 'visitor',
    initialState,
    reducers: {
        resetVisitorSlice: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllVisitors.pending, (state) => {
            state.visitors.loading = true;
            state.visitors.hasError = false;
        })
            .addCase(fetchAllVisitors.fulfilled, (state, action) => {
            state.visitors.loading = false;
            state.visitors.response = action.payload;
            state.visitors.hasError = false;
        })
            .addCase(fetchAllVisitors.rejected, (state, action) => {
            state.visitors.loading = false;
            state.visitors.hasError = true;
            state.visitors.error = action.payload;
        });
    },
});
export const { resetVisitorSlice } = visitorSlice.actions;
export default visitorSlice.reducer;
